<template>
	<v-card tile elevation="0" style="height: 100%; overflow-y: hidden">
		<v-card-title class="text-left card-header fixed-card-title2">
			<v-row no-gutters>
				<v-col cols="6">
					<v-toolbar-title>{{ $t('add-imaging-header') }}</v-toolbar-title>
				</v-col>
				<v-spacer />
				<v-icon color="white" @click="closeDrawer">mdi-close</v-icon>
			</v-row>
		</v-card-title>
		<v-card-text class="pa-4 pb-0 overflow-y-auto" style="height: calc(100vh - 221px)">
			<v-row dense class="ma-0">
				<v-col cols="12">
					<v-select
						:label="$t('modality')"
						v-model="selectedModality"
						:items="modalityTemplate"
						item-text="name"
						outlined
						hide-details
						:menu-props="{ maxHeight: 199, offsetY: true }"
						@change="selectedType = null">
						<template v-slot:item="{ item }">
							<v-tooltip left>
								<template v-slot:activator="{ on, attrs }">
									<span v-bind="attrs" v-on="on" style="width: 100%">
										{{ item.name }}
									</span>
								</template>
								{{ item.description }}
							</v-tooltip>
						</template>
					</v-select>
				</v-col>
			</v-row>

			<v-row dense class="ma-0">
				<v-col cols="12">
					<v-select
						:label="$t('body-part')"
						v-model="selectedPart"
						:items="bodyPartTemplate"
						item-text="bodyPart"
						outlined
						hide-details
						:menu-props="{ maxHeight: 199, offsetY: true }">
						<template v-slot:item="{ item }">
							<v-tooltip left>
								<template v-slot:activator="{ on, attrs }">
									<span v-bind="attrs" v-on="on" style="width: 100%">
										{{ item.bodyPart }}
									</span>
								</template>
								{{ item.description }}
							</v-tooltip>
						</template>
					</v-select>
				</v-col>
			</v-row>

			<v-row dense class="ma-0">
				<v-col cols="12">
					<v-textarea v-model="notes" :label="$t('findings')" outlined hide-details rows="12" />
				</v-col>
			</v-row>

			<v-row dense class="ma-0">
				<v-col cols="12">
					<v-file-input
						v-model="file"
						:label="$t('select-file')"
						outlined
						show-size
						prepend-icon=""
						append-icon="mdi-file-upload" />
				</v-col>
			</v-row>
		</v-card-text>
		<v-container class="px-4">
			<v-row dense class="ma-0">
				<v-col cols="12">
					<InputTimeFormatter
						:inputValue="timeSpentSeconds"
						@update:inputValue="(val) => (timeSpentSeconds = val)"
						:dense="false"
						:inputLabel="$t('time-spent')" />
				</v-col>
			</v-row>
			<v-row dense class="ma-0">
				<v-col cols="6" order="1">
					<v-btn @click="closeDrawer()" color="secondary" style="color: black" block>
						{{ $t('cancel') }}
					</v-btn>
				</v-col>
				<v-tooltip top v-if="!addButtonEnabled">
					<template v-slot:activator="{ on, attrs }">
						<v-col cols="6" v-bind="attrs" v-on="on" order="2">
							<v-btn disabled block>{{ $t('add') }}</v-btn>
						</v-col>
					</template>
					<span>{{ $t('fill-all-fields-warning') }}</span>
				</v-tooltip>
				<v-col cols="6" v-else order="2">
					<v-btn @click="addImaging()" color="dark_purple" style="color: white" block>
						{{ $t('add') }}
					</v-btn>
				</v-col>
			</v-row>
		</v-container>
	</v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import InputTimeFormatter from '../Client/components/InputTimeFormatter.vue';

export default {
	name: 'CCMImagingAdd',
	components: { InputTimeFormatter },
	data () {
		return {
			notes: '',
			timeSpentSeconds: 0,
			file: null,
			selectedPart: null,
			selectedModality: null,
			bodyPartTemplate: null,
			modalityTemplate: null,
			// extensionList: [
			// 	'image/jpg',
			// 	'image/png',
			// 	'image/webp',
			// 	'image/jpeg',
			// 	'image/gif',
			// 	'image/bmp',
			// 	'image/svg',
			// 	'text/plain',
			// 	'text/csv',
			// 	'text/html',
			// 	'application/msword',
			// 	'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
			// 	'application/x-7z-compressed',
			// 	'application/zip',
			// 	'application/x-zip-compressed',
			// 	'application/vnd.rar',
			// 	'application/x-tar',
			// 	'application/pdf',
			// 	'application/vnd.ms-excel',
			// 	'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
			// 	'application/vnd.ms-powerpoint',
			// 	'application/vnd.openxmlformats-officedocument.presentationml.presentation',
			// 	'application/vnd.oasis.opendocument.presentation',
			// 	'application/vnd.oasis.opendocument.spreadsheet',
			// 	'application/vnd.oasis.opendocument.text',
			// 	'application/rtf',
			// ],
			// rules: [
			// 	(value) => !!value || this.$t('required-field'),
			// 	(value) =>
			// 		!value ||
			// 		this.extensionList.includes(value.type) ||
			// 		this.$t('please-select-valid-file-type'),
			// 	(value) =>
			// 		!value || value.size < 512000 || this.$t('file-size-limit') + ' 500 KB',
			// ],
		};
	},

	computed: {
		...mapState({
			userData: (state) => state.authentication.userData,
			currentRecord: (state) => state.ccmRecords.ccmRecord,
			detailedUser: (state) => state.users.detailedUser,
		}),

		addButtonEnabled () {
			return (
				this.notes.trim() &&
				this.timeSpentSeconds &&
				this.file &&
				this.selectedPart &&
				this.selectedModality &&
				this.timeSpentSeconds <= 7200
			);
		},
	},

	methods: {
		...mapActions({
			getImagingByPatientId: 'ccmImaging/getAllCCMImagingByPatientId',
			addCCMImaging: 'ccmImaging/addCCMImaging',
			getImagingModalityTemplate: 'ccmRecords/getImagingModalityTemplate',
			getImagingBodyPartTemplate: 'ccmRecords/getImagingBodyPartTemplate',
		}),

		async addImaging () {
			const request = new FormData();
			request.append('CcmRecordId', this.currentRecord.id);
			request.append('PatientId', this.currentRecord.patientId);
			request.append('HospitalId', this.currentRecord.hospitalId);
			request.append('Modality', this.selectedModality);
			request.append('BodyPart', this.selectedPart);
			request.append('File', this.file);
			request.append('StaffId', this.userData.id);
			request.append('Findings', this.notes);
			request.append('ImagingDate', new Date().toISOString());
			request.append('ReviewedAt', new Date().toISOString());
			request.append('TimeSpentSeconds', this.timeSpentSeconds);
			request.append('AdditionalData', '');
			this.closeDrawer();
			await this.addCCMImaging(request).then(() => {
				this.getImagingByPatientId(this.currentRecord.patientId);
			});
		},

		closeDrawer () {
			this.timeSpentSeconds = 0;
			this.notes = '';
			this.file = null;
			this.selectedPart = null;
			this.selectedModality = null;
			this.$store.commit('SET_DETAILS_DRAWER', false);
		},

		// validateFileInput (file) {
		// 	this.formValid = file;
		// },
	},
	async mounted () {
		if (!this.modalityTemplate) {
			const response = await this.getImagingModalityTemplate();
			this.modalityTemplate = response.data;
		}

		if (!this.bodyPartTemplate) {
			const response = await this.getImagingBodyPartTemplate();
			this.bodyPartTemplate = response.data;
		}
	},
};
</script>
